import React, { useState, useContext, useEffect } from 'react';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import { useForm } from 'react-hook-form';
// import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import { AnyObject } from 'react-final-form';
// import { useDispatch } from 'react-redux';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import Ownership from 'src/models/tract_detail/Ownership';
import Button from 'src/components/controls/forms/redesign/FormButton';
import IOwner from 'src/models/IOwner';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
// import actions from 'src/actions';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import OwnerTrust from 'src/models/tract_detail/add_ownership_revised/OwnerTrust';
import OwnerBOLM from 'src/models/tract_detail/add_ownership_revised/OwnerBOLM';
import OwnerStateLand from 'src/models/tract_detail/add_ownership_revised/OwnerStateLand';
import OwnerRAL from 'src/models/tract_detail/add_ownership_revised/OwnerRAL';
import OwnerJointTenant from 'src/models/tract_detail/add_ownership_revised/OwnerJointTenant';

interface IOwnerNoteDialog {
    ownerData: Ownership;
    createNewNote?: boolean;

    updateSuccesful?: (update: boolean) => void;

    refreshContainer: () => void;
    hideDialog?: () => void;
}

const OwnerNoteDialog = (props: IOwnerNoteDialog) => {
    const { register, handleSubmit, errors, reset } = useForm();
    const appContext = useContext<IAppContextState>(AppContext);
    const { response, put } = useFetch();
    // const dispatch = useDispatch();

    const [owner, setOwner] = useState<AnyObject>(null);

    useEffect(() => {
        if (props.ownerData?.id > 0) {
            setOwner(props.ownerData);
        }
    }, [props.ownerData?.id]);

    useEffect(() => {
        reset(owner);
    }, [owner]);

    // const getOwnerDetail = async () => {
    //     let ownerLookupId = props.ownerData != null ? props.ownerData?.ownerLookUpId : 0;

    //     const result: LeaseGenerationOwnerData = await get(
    //         `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leasegeneration/owner/${ownerLookupId}`
    //     );

    //     if (response.ok) {
    //         setOwner(result.ownerDetails);
    //     } else {
    //         console.log('Unable to get Owner Details!!');
    //     }
    // };

    const handleSuccesfulSave = () => {
        if (props.refreshContainer) {
            props.refreshContainer();
        }
    };

    const updateOwnerForm = async (ownerLookupId: number, ownerType: string, values: IOwner) => {
        let result = await put(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/${ownerLookupId}/edit/${ownerType}`,
            values
        ).then(() => {
            handleSuccesfulSave();
        });

        if (response.ok) {
            console.log('this is the result of the put', result);
        } else {
            console.log('error occured while trying to update owner note!!!', result);
        }
    };

    const submitValues = (values: AnyObject) => {
        switch (owner?.ownerType) {
            case 'Individual':
                let updatedOwnerIndividual = new OwnerIndividual(owner as OwnerIndividual);
                updatedOwnerIndividual.note = values ? values.note : '';
                updateOwnerForm(updatedOwnerIndividual?.ownerLookUpId, 'owner-individual', updatedOwnerIndividual as IOwner);
                props.hideDialog();

                break;
            case 'Business':
                let updatedOwnerBusiness = new OwnerBusiness(owner as OwnerBusiness);
                updatedOwnerBusiness.note = values ? values.note : '';
                updateOwnerForm(updatedOwnerBusiness?.ownerLookUpId, 'owner-business', updatedOwnerBusiness as IOwner);
                props.hideDialog();

                break;
            case 'Trust':
                let updatedOwnerTrust = new OwnerTrust(owner as OwnerTrust);
                updatedOwnerTrust.note = values ? values.note : '';
                updateOwnerForm(updatedOwnerTrust?.ownerLookUpId, 'owner-trust', updatedOwnerTrust as IOwner);

                props.hideDialog();

                break;
            case 'Gov-BLM':
                let updatedBOLMOwner = new OwnerBOLM(owner as OwnerBOLM);
                updatedBOLMOwner.note = values ? values.note : '';
                updateOwnerForm(updatedBOLMOwner?.ownerLookUpId, 'owner-gov-bolm', updatedBOLMOwner as IOwner);
                props.hideDialog();

                break;
            case 'Gov-RAL':
                let updatedRALOwner = new OwnerRAL(owner as OwnerRAL);
                updatedRALOwner.note = values ? values.note : '';
                updateOwnerForm(updatedRALOwner?.ownerLookUpId, 'owner-gov-ral', updatedRALOwner as IOwner);
                props.hideDialog();

                break;
            case 'Gov-STATE':
                let updatedStateLandOwner = new OwnerStateLand(owner as OwnerStateLand);
                updatedStateLandOwner.note = values ? values.note : '';
                updateOwnerForm(updatedStateLandOwner?.ownerLookUpId, 'owner-state-land', updatedStateLandOwner as IOwner);
                props.hideDialog();
                break;
            // TODO: Joint Tenant does not have a note, ask if it needs one.
            case 'JointTenant':
                let updatedJointTenant = new OwnerJointTenant(owner as OwnerJointTenant);
                updatedJointTenant.note = values ? values.note : '';
                updateOwnerForm(updatedJointTenant?.ownerLookUpId, 'owner-joint-tenant', updatedJointTenant as IOwner);
                props.hideDialog();
                break;
            default:
                return values;
        }
        return values;
    };

    const onSubmit = (values: AnyObject) => {
        submitValues(values);
    };

    return (
        <Dialog title="Owner Notes" dialogName={!!props.createNewNote ? DialogList.ADD_OWNER_NOTE : DialogList.OWNER_NOTE}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <RHFTextArea label="" name="note" register={register} errors={errors} />
                <Button text="Submit Note" intent="primary" type="submit" />
            </form>
        </Dialog>
    );
};

export default OwnerNoteDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/OwnerNoteDialog.tsx